var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigationRefresh12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10c-1.117 0-2.063-.387-2.837-1.162C2.888 8.063 2.5 7.117 2.5 6s.388-2.063 1.163-2.837C4.438 2.388 5.383 2 6.5 2c.575 0 1.125.119 1.65.357A3.8 3.8 0 019.5 3.375V2h1v3.5H7v-1h2.1a2.919 2.919 0 00-1.093-1.1A2.965 2.965 0 006.5 3c-.833 0-1.542.292-2.125.875A2.893 2.893 0 003.5 6c0 .833.292 1.542.875 2.125A2.893 2.893 0 006.5 9c.642 0 1.22-.183 1.738-.55.516-.367.879-.85 1.087-1.45h1.05A3.948 3.948 0 018.95 9.162 3.88 3.88 0 016.5 10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationRefresh12);
export default __webpack_public_path__ + "61c7a506b4b787ba13189ed4fa491189.svg";
export { ForwardRef as ReactComponent };